import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevrondown",
  "use": "icon-chevrondown-usage",
  "viewBox": "0 0 64.422 24.571",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64.422 24.571\" id=\"icon-chevrondown\">\n<g id=\"icon-chevrondown_chevrondown\">\n\t<polyline style=\"fill:none;stroke:#808080;stroke-width:10;stroke-miterlimit:10;\" points=\"2.176,4.502 32.211,19.018 \n\t\t62.246,4.502 \t\" />\n</g>\n<g id=\"icon-chevrondown_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol